// MATERIAL UI
import { Container, Grid } from "@mui/material";

// REACT
import { useEffect } from "react";

// COMPONENTS
import Title from "src/components/common/Title";
import NoFooterLayout from "src/components/core/NoFooterLayout";
import CreateStrategyComponent from "src/components/dca/CreateStrategyComponent";
import StrategiesTable from "src/components/dca/StrategiesTable";
import { RBTitle } from "src/components/dca/mock-data/mock";
import CryptoRiskWarning from "src/components/disclosures/CryptoRiskWarning";

// AMPLITUDE
import { trackEvent } from "src/Amplitude";

export default function Dca() {
  useEffect(() => {
    trackEvent("Viewed DCA page", {}, "DCA");
  }, []);
  return (
    <NoFooterLayout>
      <Container sx={{ maxWidth: { xs: "500px", md: "600px", lg: "1000px" } }}>
        <Title title={RBTitle} subtitle="Schedule orders for your favourite assets" />
        {/* UK-only high-risk warning */}
        <CryptoRiskWarning />
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={5}>
            <CreateStrategyComponent />
          </Grid>
          <Grid item xs={12} md={12} lg={7} mb={4}>
            <StrategiesTable />
          </Grid>
        </Grid>
      </Container>
    </NoFooterLayout>
  );
}
